import { Component } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
	selector: 'app-refund-policy',
	standalone: true,
	imports: [RouterModule],
	templateUrl: './refund-policy.component.html',
	styleUrl: '../../globalStyle/landing-page-footer-common.scss'
})
export class RefundPolicyComponent {
	email = 'info@beexpert.ai';

	constructor(private location: Location, private router: Router) {}

	goBack() {
		if (window.history.length > 1 && window.history.state?.navigationId > 1) {
			this.location.back();
		} else {
			this.router.navigate(['/']);
		}
	}
}
